<template>
    <div class="select-city">
        <a-form-item :colon="colon" v-if="needCountry == 1">
            <span slot="label" style="white-space: normal">{{ countryLabel || $t('web.country' /* 所属国家 */) }}</span>
            <a-select
                v-if="needCountry == 1"
                v-decorator="[
                    dataName.country_name,
                    { rules: [{ required: countryRequired, message: countryHint || `${$t('formConfig.please_select' /* 请选择 */)}${$t('web.country' /* 所属国家 */)}` }] }
                ]"
                :placeholder="countryHint || `${$t('formConfig.please_select' /* 请选择 */)}${$t('web.country' /* 所属国家 */)}`"
                @change="handleCountryChange"
            >
                <a-select-option :value="items.id" v-for="(items, country_index) in countryList" :key="country_index">
                    {{ items.name }}
                </a-select-option>
            </a-select>
        </a-form-item>
        <a-form-item :colon="colon" v-if="provinceList && provinceList.length && needCountry != 1">
            <span slot="label" style="white-space: normal">{{ cityLabel || $t('web.province' /* 所属省份 */) }}</span>
            <a-row :gutter="[15, 0]">
                <a-col class="index-enter-item" :xs="8" :sm="8" :lg="8" :xl="8" :xxl="8">
                    <a-select
                        v-decorator="[dataName.province_name, { rules: [{ required: cityRequired, message: `${$t('formConfig.please_select' /* 请选择 */)}${$t('web.province' /* 所属省份 */)}` }] }]"
                        :placeholder="$t('formConfig.please_select' /* 请选择 */)"
                        @change="handleProvinceChange"
                    >
                        <a-select-option :value="itemss.id" v-for="(itemss, indexs) in provinceList" :key="indexs">
                            {{ itemss.name }}
                        </a-select-option>
                    </a-select>
                </a-col>
                <a-col v-if="cityList && cityList.length" class="index-enter-item" :xs="8" :sm="8" :lg="8" :xl="8" :xxl="8">
                    <a-form-item :colon="colon">
                        <a-select
                            :placeholder="$t('formConfig.please_select' /* 请选择 */)"
                            v-decorator="[dataName.city_name, { rules: [{ required: cityRequired, message: `${$t('formConfig.please_select' /* 请选择 */)}${$t('web.city' /* 所属城市 */)}` }] }]"
                            @change="handleCityChange"
                        >
                            <a-select-option :value="item_city.id" v-for="(item_city, city_index) in cityList" :key="city_index">
                                {{ item_city.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col v-if="needCountry != 4 && areaList && areaList.length" class="index-enter-item" :xs="8" :sm="8" :lg="8" :xl="8" :xxl="8">
                    <a-form-item :colon="colon">
                        <a-select
                            :placeholder="$t('formConfig.please_select' /* 请选择 */)"
                            v-decorator="[dataName.area_name, { rules: [{ required: cityRequired, message: `${$t('formConfig.please_select' /* 请选择 */)}${$t('web.district' /* 所属地区 */)}` }] }]"
                        >
                            <a-select-option :value="item_area.id" v-for="(item_area, area_index) in areaList" :key="area_index">
                                {{ item_area.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
            </a-row>
        </a-form-item>
    </div>
</template>

<script>
let timer = null;
export default {
    name: 'Advice',
    props: {
        needCountry: {
            type: String | Number, //1只需要国家 2只需要省市区 3全都需要 4只要省市
            default: 1
        },
        countryLabel: {
            type: String,
            default: ''
        },
        cityLabel: {
            type: String,
            default: ''
        },
        cityRequired: {
            type: Boolean,
            default: true //城市是否必填
        },
        countryRequired: {
            type: Boolean,
            default: true //国家是否必填
        },
        colon: {
            type: Boolean,
            default: true
        },
        dataName: {
            type: Object,
            default: () => {
                return {
                    country_name: 'country_id',
                    province_name: 'province_id',
                    city_name: 'city_id',
                    area_name: 'area_id'
                };
            }
        },
        dataValue: {
            type: Object,
            default: () => {
                return {
                    country_id: null,
                    province_id: null,
                    city_id: null,
                    area_id: null
                };
            }
        },
        form: {
            type: Object,
            default: null
        },
        countryHint: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            countryList: [],
            provinceList: [],
            cityList: [],
            areaList: []
        };
    },

    components: {},

    computed: {},

    watch: {
        dataValue: {
            handler(newVal) {
                this.showDataFun();
            },
            deep: true,
            immediate: true
        }
    },

    methods: {
        handleCountryChange(e) {
            this.provinceList = this.countryList[e - 1].list;
            this.cityList = [];
            this.areaList = [];
            // 清空下一级默认数据
            (this.form || this.$parent.form).setFieldsValue({ [this.dataName.province_name]: '' });
        },
        handleProvinceChange(e) {
            this.cityList = this.filterArray(this.provinceList, e, 'list').list;
            // 清空下一级默认数据
            (this.form || this.$parent.form).setFieldsValue({ [this.dataName.city_name]: '' });
            this.areaList = [];
        },
        handleCityChange(e) {
            this.areaList = this.filterArray(this.cityList, e, 'list').list;
            // 清空下一级默认数据
            (this.form || this.$parent.form).setFieldsValue({ [this.dataName.area_name]: '' });
        },
        filterArray(arr, id, type) {
            if (arr) {
                return arr.find(item => {
                    if (item.id == id) {
                        return type == 'list' ? item.list : item.name;
                    }
                });
            }
        },

        // 数据回显操作
        showDataFun() {
            this.$store.dispatch('getAddress').then(res => {
                this.countryList = res;
                let { country_id, province_id, city_id, area_id } = this.dataValue;
                let { country_name, province_name, city_name, area_name } = this.dataName;
                // 获取回显的国家省市区的列表数据
                if (this.needCountry == 2 || this.needCountry == 4) {
                    this.provinceList = this.countryList[42]?.list;
                }
                province_id && (this.provinceList = this.countryList[42]?.list);
                city_id && (this.cityList = this.filterArray(this.provinceList, province_id, 'list')?.list);
                area_id && (this.areaList = this.filterArray(this.cityList, city_id, 'list')?.list);

                // 数据回显
                this.$nextTick(() => {
                    // 设置字段
                    let fileds = [country_name, province_name, city_name, area_name];
                    fileds.forEach(v => {
                        v && (this.form || this.$parent.form).getFieldDecorator(v);
                    });
                    country_id && (this.form || this.$parent.form).setFieldsValue({ [country_name]: this.countryList[country_id - 1]?.id });
                    province_id && (this.form || this.$parent.form).setFieldsValue({ [province_name]: this.filterArray(this.provinceList, province_id, 'name')?.id });
                    city_id && (this.form || this.$parent.form).setFieldsValue({ [city_name]: this.filterArray(this.cityList, city_id, 'name')?.id });
                    area_id && (this.form || this.$parent.form).setFieldsValue({ [area_name]: this.filterArray(this.areaList, area_id, 'name')?.id });
                });
            });
        }
    },
    created() {},
    mounted() {},
    destroyed() {}
};
</script>
<style lang="less" scoped>
.select-city {
    .index-enter-item {
        /deep/.ant-row {
            margin-bottom: 0 !important;
        }
    }
    /deep/.ant-input,
    /deep/.ant-select-selection--single {
        height: 36px;
    }
    // /deep/.ant-form-item-label {
    // height: 42px;
    // line-height: 100%;
    // display: flex;
    // justify-content: flex-end;
    // align-items: center;
    // }
}
</style>
